<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r0apWz/images/cover.jpg?1733067571869" alt="This image is the cover for the book Strength of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strength of Love
      </h1>
      <p class="bookDescription body article font2">
        <p>Healing from Heartbreak with Love and Purpose</p><p><b>BBC anchor and author Kate Garraway shares how love’s resilience has helped her and her family through the loss of her husband.</b></p><p><b>Moving forward takes a lot of love. </b>After caring for her husband during his fight with Covid, Kate Garraway and her family had to face life without him in a post-pandemic world. When Derek was gone, their love helped Kate through the hardest times. <i>The Strength of Love</i> is a grief book full of honest conversations about the struggles that Kate faced and how she still found love from friends, family, herself, and Derek’s memory. With each chapter covering incredible moments in Kate’s relationship with love and grief, discover how much love can give you during periods of loss, confusion, and desperation.</p><p><b>Take a leap of faith into a hopeful future.</b> Grief made the present harder and the next chapter of Kate’s life uncertain. That is why <i>The Strength of Love</i> is not only about the comfort that love provides, it also describes how that love can bring you the strength of optimism. Inside, you’ll learn how to find the light when the heartbreak comes back. And with beautiful words of affirmation, you too will discover that love may not heal all wounds, but it will keep you strong and resilient when you need it most.</p><p><b>Follow Kate’s journey and what she discovered about love and grief, including:</b></p>Ways your body reacts after losing a loved oneHow grief is not temporary, but a piece of your identityWhat people don’t say about the dark side of mourningWhy bereavement is an ongoing process<p></p><p></p><p><b>If you are looking for a death of a loved one book such as <i>Conscious Grieving</i>,<i> In Love</i>, or<i> Sex After Grief</i>, then <i>The Strength of Love</i> is the perfect book for you.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Garraway
      </h2>
      
      <p class="authorDescription body article"><P><B>Kate Garraway</B> is a British radio and television anchor known for her contribution to UK news since 1984. Growing up in Abingdon-on-Thames, she went on to earn her degree at the Bath Spa University before starting her career with ITV News Central&#8217;s South team. Before long, Kate would present popular UK news such as <I>GMTV Today</I>, <I>Daybreak</I>, and <I>Good Morning Britain</I>, becoming one of the most recognizable presenters in history. Some of her other famous works include <I>Wall of Fame</I>, <I>Dancing with the Stars</I>, and the relaunch of Smooth Radio, gaining her 2.3 million listeners. Kate dedicates her two books, <I>The Power of Hope</I> and <I>The Strength of Love,</I> to her late husband, Derek Draper, who passed from complications with COVID-19 in 2024. She currently lives in London, England, with their children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Blink
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d3e3f644